import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './app/App';
import { setupi18n } from './i18n/i18nConfig';
import './index.css';
import { mgPrisConfig } from '@retail/mgpris/config';
import { MgPrisContextProvider } from '@retail/app/stores/app-config';
import { LicenseInfo } from '@mui/x-license';
import 'dayjs/locale/nb';
import 'dayjs/locale/sv';
import dayjs from 'dayjs';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import relativeTime from 'dayjs/plugin/relativeTime';
import Hotjar from '@hotjar/browser';
import { isRunnningLocally } from './app/isRunningLocally';

LicenseInfo.setLicenseKey(mgPrisConfig.muiLicenseKey);
dayjs.extend(isLeapYear);
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);
dayjs.updateLocale('nb', {
  weekdaysShort: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
});
dayjs.locale('sv');
setupi18n();

if (mgPrisConfig.hotjar && !isRunnningLocally) {
  Hotjar.init(mgPrisConfig.hotjar.id, mgPrisConfig.hotjar.version);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <MgPrisContextProvider config={mgPrisConfig}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MgPrisContextProvider>
  </StrictMode>
);
